const questionTypeDict = {
	/**
	 * 单选
	 */
	radio: '1',
	/**
	 * 多选
	 */
	checkbox: '2',
	/**
	 * 填空
	 */
	fillBlank: '3',
	/**
	 * 矩阵填空
	 */
	matrixFillBlank: '4',
	/**
	 * 下拉
	 */
	select: '5',
	/**
	 * 简答
	 */
	briefAnswer: '6',
	/**
	 * 量表题
	 */
	scale: '7',
	/**
	 * 民族
	 */
	nationality: '8',
	/**
	 * 省市区
	 */
	district: '9',
	/**
	 * 单项填空
	 */
	individualFillBlank: '10'
}

export {
	questionTypeDict
}


// WEBPACK FOOTER //
// ./src/utils/dict.js